import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { Table, Image } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa'
import { activeStatus, fetchAllDataByIDAPI, removeDataFromList } from '../utils/api'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import moment from 'moment'
import { BASEAGENTURLS } from '../utils/BaseUrl'

const Agent = () => {
    const [isLoading, setIsloading] = useState(false);
    const centerid = localStorage.getItem('centerdata');
    const [agent, setAgent] = useState([]);

    useEffect(() => {
        getAllAgent(centerid);
    }, [centerid]);

    const getAllAgent = (centerid) => {
        setIsloading(true);
        fetchAllDataByIDAPI(`center-get-all-agent-data/${centerid}`).then((res) => {
            if (res.data.status === 1) {
                setIsloading(false)
                setAgent(...[res.data.agentdata]);
            }
            else {
                setIsloading(false)
                toast.warning("Check your connection")
            }
        })
    }

    const handleAgentRemove = (agentid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('center-remove-center-agent-data', agentid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getAllAgent(centerid);
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    const handleAgentActive = (agentid) => {
        activeStatus('center-active-center-agent-status', agentid).then((res) => {
            if (res.data.status === 1) {
                getAllAgent(centerid);
            }
        })
    }
    const handleAgentInactive = (agentid) => {
        activeStatus('center-inactive-center-agent-status', agentid).then((res) => {
            if (res.data.status === 1) {
                getAllAgent(centerid);
            }
        })
    }

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR:WAREHOUSE::ALL AGENTS</title>
            </Helmet>

            <ContentWrapper>
                <div className="page-wrapper breadcum">
                    <div className="page-breadcrumb btnbreadcrum d-none d-sm-flex align-items-center justify-between">
                        <div className="">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">All Agents</li>
                                </ol>
                            </nav>
                        </div>
                        <Link to="/add-agent" className="btn btn-md btn-info"><FaPlus /> Add Agent</Link>
                    </div>
                    <div className="col-12 col-lg-12 col-xl-12">
                        <div className="card tablecard">
                            <div className="table-responsive">
                                <Table responsive="lg" striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>EMP ID</th>
                                            <th>Team Name</th>
                                            <th>Create Date</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ?
                                            <>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                    <td><Skeleton animation="wave" variant="text" /></td>
                                                </tr>
                                            </>

                                            :
                                            agent?.map((agent, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td><Image className="rounded-circle" width={30} src={BASEAGENTURLS(agent?.agent_foto)} /></td>
                                                    <td>{agent?.agent_name}</td>
                                                    <td><span className="badge badge-info">{agent?.agent_emp_id}</span></td>
                                                    <td><span className="badge badge-secondary">{agent?.mis_name}</span></td>
                                                    <td>{moment(agent?.agent_create_date).format('Do MMMM YYYY, h:mm A')}</td>
                                                    <td>
                                                        {(() => {
                                                            if (agent?.agent_status === "Active") {
                                                                return (
                                                                    <button className="badge bg-success btnstatus" onClick={() => handleAgentActive(agent?.center_agent_id)}>Active</button>
                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    <button className="badge bg-danger btnstatus" onClick={() => handleAgentInactive(agent?.center_agent_id)}>Inactive</button>
                                                                )
                                                            }
                                                        })()}
                                                    </td>
                                                    <td className="btnsection">
                                                        <Link to={`/edit-agent/${agent?.center_agent_id}`} className="btnEdit"><FaEdit /></Link>
                                                        <button className="btnDelete" onClick={() => handleAgentRemove(agent?.center_agent_id)}><FaTrashAlt /></button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                            <th>#</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>EMP ID</th>
                                            <th>Team Name</th>
                                            <th>Create Date</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </tfoot>
                                </Table>

                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default Agent